// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/composite-flight-plans.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/composite-flight-plans/composite-flight-plans.js';

mount([g0]);
